import type { HttpClient } from '@/utils/HttpClient';

export type SequenceService = {
  getSequencesByCategory: (categorySlug: string) => Promise<unknown>;
};

const setHeaders = (): object => ({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const SequenceService = (httpClient: HttpClient): SequenceService => {
  return {
    getSequencesByCategory(categorySlug) {
      return httpClient({
        endpoint: `/attribute-sequence/${categorySlug}/1`,
        method: 'GET',
        ...setHeaders(),
      });
    },
  };
};
